import { CaretLeft, CaretRight, CircleNotch } from "@phosphor-icons/react";

/** Barra de paginação: "1–50 de 1.707" + Anterior/Próxima. `page` é 1-based. */
export const Pagination = ({ page, pageSize, total, onChange, loading = false, testId = "pagination", label = "registro(s)" }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  const from = total ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(page * pageSize, total || 0);
  const btn = "inline-flex items-center gap-1 min-h-[40px] px-3 rounded-lg border border-zinc-800 text-sm text-zinc-300 hover:bg-zinc-800 disabled:opacity-40 disabled:hover:bg-transparent transition-colors";
  return (
    <div data-testid={testId} className="flex flex-wrap items-center justify-between gap-3 mt-4 text-sm text-zinc-400">
      <span data-testid={`${testId}-summary`} className="flex items-center gap-2">
        {loading && <CircleNotch size={16} className="animate-spin text-indigo-400" data-testid={`${testId}-loading`} />}
        {total ? <>Mostrando <span className="text-zinc-200 font-medium">{from.toLocaleString("pt-BR")}–{to.toLocaleString("pt-BR")}</span> de <span className="text-zinc-200 font-medium">{total.toLocaleString("pt-BR")}</span> {label}</> : `Nenhum ${label}`}
      </span>
      <div className="flex items-center gap-2">
        <button type="button" data-testid={`${testId}-prev`} className={btn} disabled={page <= 1 || loading} onClick={() => onChange(page - 1)}>
          <CaretLeft size={16} /> Anterior
        </button>
        <span data-testid={`${testId}-page`} className="text-xs text-zinc-500 tabular-nums">página {page} de {pages}</span>
        <button type="button" data-testid={`${testId}-next`} className={btn} disabled={page >= pages || loading} onClick={() => onChange(page + 1)}>
          Próxima <CaretRight size={16} />
        </button>
      </div>
    </div>
  );
};
